import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

export interface TestimonialsBlock2Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  leftContent?: ReactNode;
  logo?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const TestimonialsBlock2 = forwardRef<
  HTMLDivElement,
  TestimonialsBlock2Props
>(
  (
    { leftContent, content, header, footer, logo, className, styles, ...rest },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-flex wb-flex-col wb-gap-10 md:wb-grid md:wb-grid-cols-2 md:wb-gap-16">
                <BlockSection.NestedBlock className="wb-mx-auto">
                  {leftContent}
                </BlockSection.NestedBlock>
                <div className="wb-flex wb-items-center">
                  <div className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                    <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                      {header}
                      {content}
                      <BlockSection.NestedBlock>
                        {footer}
                      </BlockSection.NestedBlock>
                      {logo}
                    </BlockSection.NestedBlock>
                  </div>
                </div>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

TestimonialsBlock2.displayName = "TestimonialsBlock2";
